import { DEFAULT_VALUE } from "@/config";
import type { Customer } from "@zhihaoscm/entity";
import type { Enterprise } from "@zhihaoscm/entity";
import type { Owener } from "@/entity/logistics/ownerShipNeed";

export const getCustomerName = (customer?: Customer) => {
    // TODO 后期配合吴寒后端统一返回字段
    // return customer?.institutionName || customer?.realName || customer?.nickName || "--";
    return customer?.nickName || DEFAULT_VALUE;
};

export const getEnterpriseName = (enterprise?: Enterprise): string => {
    if (!enterprise) return DEFAULT_VALUE;
    return enterprise.name || enterprise.realName || enterprise.mobile || DEFAULT_VALUE;
};

export const getCustomerAuthName = (customer?: Customer | Owener) => {
    return customer?.institutionName || customer?.realName || customer?.mobile || DEFAULT_VALUE;
};

export const getCustomerIdentityList = (customer: Customer) => {
    if (!customer.identity) return DEFAULT_VALUE;
    const result = [];
    const identities = ["采购商", "供应商", "联合购销商", "承运商"];
    const identityStringList = customer.identity.toString(2).split("").reverse();
    for (let i = 0; i < identityStringList.length; i++) {
        if (identityStringList[i] === "1") {
            result.push(identities[i]);
        }
    }
    return result.join(", ");
};
